module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manuals/manuals.component.scss
// module id = ./src/app/pages/manuals/manuals.component.scss
// module chunks = main